function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "25.02",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 15.52a9.07 9.07 0 00-6.47 2.71m2.14 2.15a6.06 6.06 0 018.66 0m0 0a6.06 6.06 0 00-8.66 0m2.15 2.14a3 3 0 014.36 0m0 0a3 3 0 00-4.36 0m14.66-3.15v.66A12.5 12.5 0 1120 7.53h.64m7.36-4a8.5 8.5 0 108.5 8.5 8.5 8.5 0 00-8.5-8.5zm3.44 7.06l-1.68-1.67 1.39-1.38a.44.44 0 01.61.06l1 1a.43.43 0 01.06.6zm-5.59 5.56l-1.71.06.04-1.73 5.58-5.56 1.68 1.67-5.59 5.56zm0 0a3.93 3.93 0 00-.75-.93 3.87 3.87 0 00-.92-.74"
}));